
export const ChessPieces = {
    KING: {fen: "k", value: Number.MAX_VALUE, getImageSrc: (color) => `/${color}_king.png`},
    QUEEN: {fen: "q", value: 9, getImageSrc: (color) => `/${color}_queen.png`},
    ROOK: {fen: "r", value: 5, getImageSrc: (color) => `/${color}_rook.png`},
    BISHOP: {fen: "b", value: 3, getImageSrc: (color) => `/${color}_bishop.png`},
    KNIGHT: {fen: "n", value: 3, getImageSrc: (color) => `/${color}_knight.png`},
    PAWN: {fen: "p", value: 1, getImageSrc: (color) => `/${color}_pawn.png`}
}

export const fenToPiece = {
    "k": ChessPieces.KING,
    "q": ChessPieces.QUEEN,
    "r": ChessPieces.ROOK,
    "b": ChessPieces.BISHOP,
    "n": ChessPieces.KNIGHT,
    "p": ChessPieces.PAWN
}
